import { isSSR } from '@sajari/react-sdk-utils';
import { useState, useEffect, useCallback } from 'react';
import useDebounce from '../useDebounce/index.esm.js';

function useQueryParam(key, options) {
  var _ref = options != null ? options : {},
      callback = _ref.callback,
      defaultValue = _ref.defaultValue,
      debounce = _ref.debounce,
      _ref$replace = _ref.replace,
      replace = _ref$replace === void 0 ? false : _ref$replace;

  var _useState = useState(undefined),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var debouncedValue = useDebounce(internalValue, debounce != null ? debounce : 0);

  var getValue = function getValue() {
    var _URLSearchParams$get;

    return !isSSR() ? (_URLSearchParams$get = new URLSearchParams(window.location.search).get(key)) != null ? _URLSearchParams$get : '' : '';
  };

  var setInternalParam = function setInternalParam(val) {
    if (typeof val === 'undefined') {
      return;
    }

    var url = new URL(window.location.href);
    var prevSearch = url.search;

    if (!Array.isArray(val) && val && val !== defaultValue || Array.isArray(val) && val.length > 0) {
      url.searchParams.set(key, val.toString());
    } else if ((val == null ? void 0 : val.toString().length) === 0 || val === defaultValue || Array.isArray(val) && val.length === 0) {
      url.searchParams["delete"](key);
    }

    if (prevSearch === url.search) {
      return;
    }

    if (replace) {
      window.history.replaceState(null, '', url.toString());
    } else {
      window.history.pushState(null, '', url.toString());
    }
  };

  var handler = function handler() {
    if (typeof callback === 'function') {
      callback(getValue());
    }
  };

  useEffect(function () {
    window.addEventListener('popstate', handler);
    return function () {
      window.removeEventListener('popstate', handler);
    };
  }, []);
  useEffect(function () {
    setInternalParam(debouncedValue);
  }, [debouncedValue]);
  var setParam = useCallback(function (val) {
    setInternalValue(val);
  }, []);
  return setParam;
}

export default useQueryParam;
//# sourceMappingURL=index.esm.js.map
